// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Summary_unit-summary__l2Fkc .Summary_update-button__H0peq {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 30px;
}`, "",{"version":3,"sources":["webpack://./src/Admin/Pages/UnitDetail/Components/Summary/Summary.module.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;AAAJ","sourcesContent":[".unit-summary {\n  .update-button {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    padding: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"unit-summary": `Summary_unit-summary__l2Fkc`,
	"update-button": `Summary_update-button__H0peq`
};
export default ___CSS_LOADER_EXPORT___;
